import { APITypes } from "@cur8/api-client";
import { TransStudies } from "lib/i18n/translations/studies";
import { Typography } from "render/ui/presentation/Typography";
import { ListItem } from "render/ui/trigger/ListItem";
import { useConsentsMap } from "./hooks/useConsentsMap";
import styles from "./styles.module.sass";
import { Trans } from "./trans";

interface ConsentSectionProps {
  onOpenConsentClick: (id: string) => void;
  consents?: APITypes.ConsentSummary[];
}

export function DataAndPrivacySection({
  onOpenConsentClick,
}: ConsentSectionProps) {
  const { studies, other } = useConsentsMap();

  return (
    <section data-hj-suppress className={styles.studiesSection}>
      <div className={styles.title}>
        <Typography variant="title-large">
          <Trans.Title />
        </Typography>
        <Typography variant="paragraph">
          <Trans.Paragraph />
        </Typography>
      </div>

      <div className={styles.consentBorder} />

      <section data-testid="studies">
        <div className={styles.sectionTitle}>
          <Typography variant="title-medium">
            <Trans.ClinicalStudies />
          </Typography>
        </div>
        <ListItem
          name={<TransStudies.Cardio.Title />}
          onClick={() => onOpenConsentClick(studies.CARDIO)}
        />
        <div className={styles.consentBorder} />
        <ListItem
          name={<TransStudies.DermaFlow.Title />}
          onClick={() => onOpenConsentClick(studies.DERMAFLOW)}
        />
        <div className={styles.consentBorder} />
        <ListItem
          name={<TransStudies.Spectrum.Title />}
          onClick={() => onOpenConsentClick(studies.SPECTRUM)}
        />
        <div className={styles.consentBorder} />
      </section>

      <section data-testid="other">
        <Typography variant="title-medium">
          <Trans.Other />
        </Typography>
        <div className={styles.consentBorder}>
          <ListItem
            name={<Trans.PatientJournal />}
            onClick={() => onOpenConsentClick(other.PATIENTJOURNAL)}
          />
        </div>
      </section>
    </section>
  );
}
